<!--Form-->
<form [formGroup]="form" (ngSubmit)="onSubmit()">
	<div class="card">
		<div class="card-body">
			<h5 class="card-title">{{title}}</h5>
			<table class="table table-striped table-bordered">
				<thead>
					<th>Model</th>
					<th>Sheet column</th>
					<th>Preview</th>
				</thead>
				<tbody>
					<ng-container formArrayName="mapping">
						<ng-container *ngFor="let _ of mapping.controls; index as in">
							<tr>
								<ng-container [formGroupName]="in">
									<td>
										{{ f[in].controls['label'].value }}
									</td>
									<td>
										<select formControlName="column" class="form-control" (change)="onColumnSelect($event, in)">
											<option value=""></option>
											<option *ngFor="let column of columns" value="{{column}}">{{column}}</option>
										</select>
									</td>
									<td>{{ f[in].controls['preview'].value }}</td>
								</ng-container>
							</tr>
						</ng-container>
					</ng-container>
					<tr *ngIf="!model?.length">
						<td colspan="3">No model provided!</td>
					</tr>
				</tbody>

			</table>
		</div>
		<div class="card-footer">
			<am-button [text]="submitButtonText" [type]="'submit'" [isLoading]="isButtonDisabled"></am-button>
			<a href="javascript:;" (click)="cancel()" class="btn btn-light ml-3">{{cancelButtonText}}</a>
		</div>
	</div>
</form>